/**
 * Haalt uit de tweede productstrook weg wat al in de eerste staat.
 *
 * WAAROM DIT NIET IN LIQUID KAN
 * De saleband ("ook deze zijn afgeprijsd") en de bestsellerrij zijn twee losse
 * Shopify-secties. Ze kiezen uit verschillende collecties en weten niets van
 * elkaar: Liquid heeft geen manier om te zien wat een andere sectie heeft
 * gerenderd. Een bestseller die ook in de sale staat verscheen daardoor twee
 * keer onder elkaar — gemeten over drie producten kwam dat één keer voor.
 *
 * De sectie rendert daarom drie reserves extra, met hun handle op de slede. Dit
 * script gooit de dubbele eruit en schuift een reserve door tot het afgesproken
 * aantal weer vol staat.
 *
 * Draait dit script niet, dan staan er gewoon de eerste vier — hooguit met een
 * dubbele. Dat is precies de oude toestand, dus falen kost niets.
 */
(function () {
  'use strict';

  function ontdubbel() {
    var doel = document.querySelector('[data-cl-ontdubbel]');
    if (!doel) return;

    var toon = parseInt(doel.getAttribute('data-cl-toon'), 10) || 4;
    var sleden = [].slice.call(doel.querySelectorAll('[data-cl-handle]'));
    if (!sleden.length) return;

    // Alles wat elders op de pagina al als productkaart staat. Niet alleen de
    // saleband: staat er ooit een derde strook, dan telt die vanzelf mee.
    var alBoven = {};
    [].forEach.call(document.querySelectorAll('a[href*="/products/"]'), function (a) {
      if (doel.contains(a)) return;
      var stuk = a.getAttribute('href').split('/products/')[1];
      if (stuk) alBoven[stuk.split('?')[0].split('#')[0]] = true;
    });

    var gezet = 0;
    sleden.forEach(function (slede) {
      var handle = slede.getAttribute('data-cl-handle');
      if (alBoven[handle] || gezet >= toon) {
        slede.remove();
        return;
      }
      slede.classList.remove('cl-pdp__kaartslede--reserve');
      gezet++;
    });

    // Bleven er te weinig over, dan is dat beter dan een dubbele: de strook
    // toont gewoon minder kaarten.
    if (!gezet) doel.closest('.cl-pdp__blok').hidden = true;
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ontdubbel);
  else ontdubbel();
})();
